import { sortingMethods } from 'src/constants/table';
import CustomCell from '../../../../components/Table/CustomCell';

export const topHeading = [
  {
    title: '',
    colSpan: 1,
    borderRight: true,
  },
  {
    title: 'Packaged app details',
    colSpan: 3,
    borderRight: true,
  },
  {
    title: 'Launch attempts',
    colSpan: 3,
    borderRight: true,
  },
];

export const secondHeadings = [
  {
    title: 'Status',
    name: 'status',
    borderRight: true,
    width: '8%',
  },
  {
    title: 'Display Name',
    name: 'displayName',
    hasSorting: true,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterPackagedAppResult',
    sortingCellField: 'displayName',
    sortFieldName: 'OrderQuery',
    width: '15%',
  },
  {
    title: 'Package Family Name',
    name: 'packageFamilyName',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterPackagedAppResult',
    sortingCellField: 'PackageFamilyName',
    sortFieldName: 'OrderQuery',
    width: '25%',
  },
  {
    title: 'Signature Kind',
    name: 'signatureKind',
    borderRight: true,
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterPackagedAppResult',
    sortingCellField: 'SignatureKind',
    sortFieldName: 'OrderQuery',
    width: '15%',
  },
  {
    title: '5 Days',
    name: 'launchAttempts5Days',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterPackagedAppResult',
    sortingCellField: 'LaunchAttempts5Days',
    sortFieldName: 'OrderQuery',
    width: '12%',
  },
  {
    title: '30 Days',
    name: 'launchAttempts30Days',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterPackagedAppResult',
    sortingCellField: 'LaunchAttempts30Days',
    sortFieldName: 'OrderQuery',
    width: '12%',
  },
  {
    title: '90 Days',
    name: 'launchAttempts90Days',
    hasSorting: false,
    sortMethod: sortingMethods.initial,
    Component: CustomCell,
    field: 'FilterPackagedAppResult',
    sortingCellField: 'LaunchAttempts90Days',
    sortFieldName: 'OrderQuery',
    borderRight: true,
    width: '12%',
  },
];

export const columnsOrder = [
  { name: 'status', styles: { width: '50px' } },
  { name: 'displayName' },
  'packageFamilyName',
  { name: 'signatureKind' },
  { name: 'launchAttempts5Days', isNumber: true },
  { name: 'launchAttempts30Days', isNumber: true },
  { name: 'launchAttempts90Days', isNumber: true },
];

export const trustedStatus = 'Trusted';
export const unknownStatus = 'Unknown';

export const packagedAppsStatusList = [
  {
    id: 'Unknown',
    label: 'No Status',
    value: 'Unknown',
    name: 'No Status',
  },
  {
    id: 'Trusted',
    label: 'Trusted',
    value: 'Trusted',
    name: 'Trusted',
  },
  {
    id: 'Untrusted',
    label: 'Untrusted',
    value: 'Untrusted',
    name: 'Untrusted',
  },
];

export const EDIT_STATUS_NOTE_INFO_LINK = 'https://www.appcontrol.ai//s/f/what-effect-does';
